import { Stack } from '@amboss/design-system';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { config } from '../../../../config';
import useCreditsPaginate from '../../../../hooks/useCreditsPaginate';
import EmptyPlaceholder from '../../../atoms/EmptyPlaceholder';
import CreditList from '../lists/CreditList';

const AvailableTab = () => {
  const { t } = useTranslation();
  const { isLoading, credits, refreshCredits } = useCreditsPaginate(
    config.tabs.AVAILABLE,
  );

  useEffect(() => {
    refreshCredits();
  }, []);

  return (
    <>
      {!isLoading && (
        <Stack space={'m'}>
          {credits?.items && credits.items.length > 0 ? (
            <CreditList credits={credits} />
          ) : (
            <EmptyPlaceholder
              header={t('credits.tabs.tab1.emptyPlaceholder.header')}
              subHeader={t('credits.tabs.tab1.emptyPlaceholder.subHeader')}
            />
          )}
        </Stack>
      )}
      {isLoading && (
        <Stack space={'m'}>
          <EmptyPlaceholder
            header={t('loading.header')}
            subHeader={t('loading.subheader')}
          />
        </Stack>
      )}
    </>
  );
};

export default AvailableTab;
